import { Skeleton } from '@robocorp/components';

const SideNavigationSkeleton = () => (
  <Skeleton width="260px" height="321px">
    <rect x="12" y="10" rx="3" ry="3" width="80" height="11" />
    <rect x="12" y="26" rx="3" ry="3" width="198" height="16" />
    <rect x="218" y="10" rx="3" ry="3" width="30" height="31" />

    <rect x="12" y="64" rx="3" ry="3" width="236" height="14" />

    <rect x="16" y="93" rx="3" ry="3" width="30" height="30" />
    <rect x="60" y="98" rx="3" ry="3" width="110" height="20" />

    <rect x="16" y="129" rx="3" ry="3" width="30" height="30" />
    <rect x="60" y="134" rx="3" ry="3" width="140" height="20" />

    <rect x="16" y="165" rx="3" ry="3" width="30" height="30" />
    <rect x="60" y="170" rx="3" ry="3" width="150" height="20" />

    <rect x="16" y="201" rx="3" ry="3" width="30" height="30" />
    <rect x="60" y="206" rx="3" ry="3" width="140" height="20" />
  </Skeleton>
);

export default SideNavigationSkeleton;
